const styleSheet = () => ({
  cardContainer: {
    width: '100%',
    minHeight: '134px',
    maxWidth: '320px',
    margin: '0 auto',
    '& textarea': {
      width: '100%',
      height: '67px',
      resize: 'none',
      border: '1.2px solid #B7C1E1',
      borderRadius: '3.6px',
      fontFamily: "'Museo Sans', sans-serif",
      fontWeight: 500,
      color: '#051D39',
      fontSize: '14px',
      padding: '10px',
      boxSizing: 'border-box',
    },
  },
  error: {
    color: '#FF6969',
    fontSize: '12px',
    letterSpacing: 0,
    padding: '0 14px',
    marginTop: '5px',
    alignSelf: 'end',
  },
  cardDescription: {
    color: '#051D39',
    fontSize: '14px',
    height: '60px',
    width: '96%',
    display: 'inline-block',
  },
  footer: {
    marginTop: '3px',
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    flex: 1,
  },
  matches: {
    display: 'flex',
    alignItems: 'baseline',
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
    width: '100%',
    '& .text': {
      fontSize: '12px',
    },
    '& .count': {
      fontSize: '28px',
      marginRight: '5px',
    },
  },
  limitCharacterText: {
    position: 'absolute',
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0',
    lineHeight: '15px',
    height: '15px',
    width: '115px',
    color: '#FF6969',
    bottom: '-25px',
    left: '8px',
  },
});

export default styleSheet;
